import { CREATE_BRAND_PROJECT_ROUTE_ID, LOGIN_ROUTE_ID } from 'root/src/shared/descriptions/routes/routeIds'
import { GET_STARTED_MODULE_ID } from 'root/src/shared/descriptions/modules/moduleIds'
import { colorsNew } from 'root/src/client/web/commonStyles'
import {
	levelKey,
	platformKey,
} from 'root/src/shared/constants/keys'
import {
	dropDareDifficultyLevelEnum,
	readableDropDareDifficultyLevels,
} from 'root/src/shared/constants/dropEvent'
import { faSignIn } from '@fortawesome/pro-light-svg-icons/faSignIn'
import { faBadgeCheck } from '@fortawesome/pro-light-svg-icons/faBadgeCheck'
import { faGamepadAlt } from '@fortawesome/pro-light-svg-icons/faGamepadAlt'
import ANCHORS from 'root/src/shared/constants/anchors'
import { darePlatformFilters } from 'root/src/client/v2/drop/constants'
import { getReadablePlatform } from 'root/src/shared/platforms/helpers/getReadablePlatform'

export default {
	howToSection: {
		title: 'New Here?',
		subtitle: 'You’ll catch on quick. Here’s how to get started on Dare Drop:',
		steps: [
			{
				icon: { icon: faSignIn, color: colorsNew.primary },
				cta: 'Sign Up',
				content: 'First, create an account. It’s totally free, no cost to you.',
			},
			{
				icon: { icon: faBadgeCheck, color: colorsNew.pink },
				cta: 'Accept Dares',
				content: 'Accept any (or all!) of the dares you want to try on this page.',
			},
			{
				icon: { icon: faGamepadAlt, color: colorsNew.teal },
				cta: 'Play Games',
				content: 'We’ll email you a game key. Play the game and win rewards for your fans! ',
			},
		],
		buttons: [{
			label: 'Sign Up',
			moduleId: GET_STARTED_MODULE_ID,
			type: 'primary',
		},
		{
			anchorId: ANCHORS.DROP_FAQ_SECTION,
			label: 'Read some FAQs',
			type: 'secondary',
		}],
	},
	daresSection: {
		primaryHeading: 'The Drop—',
		secondaryHeading: gameName => `All Dares for ${gameName}`,
		linkRouteId: LOGIN_ROUTE_ID,
		redirectRouteId: CREATE_BRAND_PROJECT_ROUTE_ID,
		filters: {
			[platformKey]: darePlatformFilters
				.map(({ value: platform }) => ({
					value: platform,
					label: getReadablePlatform(platform),
				})),
			[levelKey]: Object.values(dropDareDifficultyLevelEnum)
				.map(level => ({
					value: level,
					label: readableDropDareDifficultyLevels[level],
				})),
		},
		loggedInText: 'Click on one to get started.',
		notLoggedInText: 'Sign in to start accepting dares.',
	},
}
